import React from "react";
import PropTypes from "prop-types";

const CustomTooltip = ({ tooltipContent, payload, ...props }) => {
  if (tooltipContent) {
    return (
      <div className="chart__tooltip-container">{tooltipContent} days</div>
    );
  }
  return null;
};

CustomTooltip.defaultProps = {
  tooltipAccessor: "",
  payload: null,
};

CustomTooltip.propTypes = {
  tooltipAccessor: PropTypes.string,
  payload: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
};

export default CustomTooltip;
